import { concat, filter, forEach, includes } from 'lodash';

// This function is for data sync in client grid after save mutation call
export const syncEntity = (existing, incoming, deleted, key = 'tag') => {
  // Filter out deleted
  let items = filter(existing, (existingItem) => !includes(deleted, existingItem.id) || !existingItem?.id);
  // Incoming are successfully saved
  forEach(incoming, (incomingItem) => {
    const foundItemIndex = items.findIndex((item) => item[key] === incomingItem[key]);
    if (foundItemIndex > -1) {
      items[foundItemIndex] = { ...items[foundItemIndex], ...incomingItem };
    } else {
      items = concat(items, incomingItem);
    }
  });
  return items;
};
